import { render, staticRenderFns } from "./SenderList.vue?vue&type=template&id=d449c2c2&scoped=true&"
import script from "./SenderList.vue?vue&type=script&lang=js&"
export * from "./SenderList.vue?vue&type=script&lang=js&"
import style0 from "./SenderList.vue?vue&type=style&index=0&id=d449c2c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d449c2c2",
  null
  
)

export default component.exports